import { mixins } from "epsy-ui-react"

const { invisible, shadow, normalizeInput, normalizeButton, toEdges, loadingPulseAnimation } = mixins
export { invisible, shadow, normalizeInput, normalizeButton, toEdges, loadingPulseAnimation }
